import * as React from "react";
import { Modal, Button, Tabs } from "antd";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";
import FormConfigQualifierAttribute, {
  IFormConfigQualifierAttribute
} from "../../../service/formconfiguration/FormConfigQualifierAttribute";

const { TabPane } = Tabs;

const SELECT_EXISTING_ATTRIBUTE_TAB_KEY = "selectExistingAttribute";
const NEW_ATTRIBUTE_TAB_KEY = "newAttribute";

export interface State {
  selectedTabKey: string;
}

export interface Props {
  translate: any;
  visible?: boolean;
  onCancel?: any;
  CreateAttributeForm: any;
  AttributeSelectionForm: any;
  createFormConfigQualifierAttribute(
    parentFormConifgSectionQualifier: IFormConfigSectionQualifier,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  attributes?: any;
  parentQualifier: IFormConfigSectionQualifier;
}

export default class AddAttributeModal extends React.Component<Props, State> {
  private existingAttributeFormSubmitHandler: any;
  private newAttributeFormSubmitHandler: any;

  constructor(props) {
    super(props);
    this.state = {
      selectedTabKey: SELECT_EXISTING_ATTRIBUTE_TAB_KEY
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.registerExistingAttributeFormSubmitHandler = this.registerExistingAttributeFormSubmitHandler.bind(
      this
    );
    this.registerNewAttributeFormSubmitHandler = this.registerNewAttributeFormSubmitHandler.bind(
      this
    );
  }

  registerExistingAttributeFormSubmitHandler(registrationHandler) {
    this.existingAttributeFormSubmitHandler = registrationHandler;
  }

  registerNewAttributeFormSubmitHandler(registrationHandler) {
    this.newAttributeFormSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const {
      createFormConfigQualifierAttribute,
      onCancel,
      parentQualifier
    } = this.props;
    const { selectedTabKey } = this.state;

    if (
      this.existingAttributeFormSubmitHandler ||
      this.newAttributeFormSubmitHandler
    ) {
      let newData;

      switch (selectedTabKey) {
        case SELECT_EXISTING_ATTRIBUTE_TAB_KEY:
          newData = this.existingAttributeFormSubmitHandler(e);
          if (newData) {
            createFormConfigQualifierAttribute(
              parentQualifier,
              FormConfigQualifierAttribute({ ...newData })
            );
            onCancel();
          }
          break;
        case NEW_ATTRIBUTE_TAB_KEY:
          newData = this.newAttributeFormSubmitHandler(e);
          if (newData) {
            createFormConfigQualifierAttribute(
              parentQualifier,
              FormConfigQualifierAttribute({ ...newData })
            );
            onCancel();
          }
          break;
      }
    }
  }

  render() {
    const {
      translate,
      visible,
      onCancel,
      CreateAttributeForm,
      AttributeSelectionForm,
      attributes
    } = this.props;

    return (
      <div onClick={(e) => e.stopPropagation()}>
        <Modal
          title={translate("create_attribute_modal.title")}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.insert_modal.cancel")}
            </Button>,
            <Button key="submit" type="danger" onClick={this.onSubmit}>
              {translate("modal_functions.insert_modal.add")}
            </Button>
          ]}
        >
          <Tabs
            defaultActiveKey={SELECT_EXISTING_ATTRIBUTE_TAB_KEY}
            onChange={(activeKey) =>
              this.setState({ selectedTabKey: activeKey })
            }
          >
            <TabPane
              tab={translate(
                "create_attribute_modal.add_existing_attribute_tab.tab_name"
              )}
              key={SELECT_EXISTING_ATTRIBUTE_TAB_KEY}
            >
              <AttributeSelectionForm
                translate={translate}
                registerFormSubmitEventHandler={
                  this.registerExistingAttributeFormSubmitHandler
                }
                attributes={attributes}
              ></AttributeSelectionForm>
            </TabPane>
            <TabPane
              tab={translate(
                "create_attribute_modal.add_new_attribute_tab.tab_name"
              )}
              key={NEW_ATTRIBUTE_TAB_KEY}
            >
              <CreateAttributeForm
                translate={translate}
                registerFormSubmitEventHandler={
                  this.registerNewAttributeFormSubmitHandler
                }
              ></CreateAttributeForm>
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    );
  }
}
